var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('el-button',{attrs:{"type":"primary","disabled":!_vm.status,"size":_vm.type},on:{"click":_vm.getCode}},[_vm._v(_vm._s(_vm.$t('user.activation')))]):_c('el-button',{staticClass:"timing-info-cla",attrs:{"type":"info","size":"medium"}},[_vm._v(_vm._s(_vm.numCount)+" s")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1767e8d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timing.vue
// module id = null
// module chunks = 